/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import Button, { TButtonProps } from '@client/components/Button';

import type { TUpgradeTrackingInfos } from '@/server/services/utils/Payments';

/*----------------------------------
- TYPES
----------------------------------*/
export type TSubscribeCTAProps = TButtonProps & TUpgradeTrackingInfos & {
    action: 'demo' | 'now',
    plan: string,
}

/*----------------------------------
- COMPONENT
----------------------------------*/
export default ({ action, plan, motivation, feature, ...props }: TSubscribeCTAProps) => {
    const link = `/user/upgrade/${action}?plan=${plan}&feature=${feature}&motivation=${encodeURIComponent(motivation)}`;
    return (
        <Button target="_blank" link={link} {...props} />
    )
}
